export default {"src":"/_next/static/media/equipment_rental.76966c2a.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};